/* eslint-disable semi,semi-style */
import React, { FunctionComponent, useEffect } from 'react';
import request from '@/util/request';
import { loadCss, loadScript, removeRes } from '@/util/loadFile';
import style from './index.module.scss';
import platforms from '../../config';
import useSWR from 'swr';

type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[]
  ? ElementType
  : never;

interface LoaderProps {
  source: ArrayElement<typeof platforms>;
}

interface SubAppResource {
  linkUrls: string[];
  scriptUrls: string[];
}

const Loader: FunctionComponent<LoaderProps> = ({ source }) => {
  useEffect(() => {
    window.webpackJsonp = [];
    removeRes();
    return () => {
      // 路由切换前卸载当前应用
      const { node } = source;
      window._connect && window._connect[node] && window._connect[node](document.querySelector(`#${node}`));
    };
  }, [source]);

  const { data, error } = useSWR<SubAppResource>(
    ['/open-platform-web/api/monitor/tool/queryHtmlInfo', source.res],
    (url, res) =>
      request(url, {
        params: {
          urlStr: res,
        },
      }) as any,
  );
  console.log(data, error);
  useEffect(() => {
    if (!data) return;
    data.linkUrls.forEach(link => {
      loadCss(link);
    });
    data.scriptUrls.forEach(script => {
      loadScript(script);
    });
  }, [data]);

  return (
    <div id={source.node}>
      <div className={style.resLoading}>
        <div className={style.loading}></div>
        <div className={style.loadingText}>加载中，请稍后...</div>
      </div>
    </div>
  );
};

export default Loader;
